import './App.css';
import Hero from './components/home/Hero';

function App() {
  return (
    <>
    <Hero/>
    </>
  );
}

export default App;
